import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product3",
  "use": "icon-product3-usage",
  "viewBox": "0 0 59 57",
  "content": "<symbol viewBox=\"0 0 59 57\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product3\">\n<path d=\"M40.9938 50.4282H18.1344V55.8104H6.70476V50.4282H1V27.5688H10.5953V36.378H48.5531V27.5688H58.1483V50.4282H52.4234V55.8104H40.9938V50.4282Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M5.55566 22.6902V1H53.5724V22.6902\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol